import toolsClient from "@/api/toolsClient";
import axios from "axios";

let tokenData = {};
let libraryClient = {};
let uploaderClient = {};

function getLibraryClient(tokenData) {
  let config = {
    baseURL: tokenData.url,
    headers: {
      "X-Auth-Token": tokenData.token,
    },
  };

  return axios.create(config);
}

function getUploaderClient(tokenData) {
  let config = {
    baseURL: tokenData.uploader,
    headers: {
      "X-Auth-Token": tokenData.token,
    },
  };

  return axios.create(config);
}

export const getLibrary = async (stationKey) => {
  let response = await toolsClient.get(`stations/${stationKey}/library_token/`);

  tokenData = response.data;

  libraryClient = getLibraryClient(tokenData);
  uploaderClient = getUploaderClient(tokenData);

  return response.data;
};

export const getMediaByRef = async (playlist) => {
  let response = await libraryClient.get(
    `/api/media/?reference=${playlist.join(",")}`
  );

  return response.data.data;
};

export const uploadMediaFile = async (file) => {
  let data = new FormData();

  data.append("name", file.name);
  data.append("file", file);

  let response = await uploaderClient.post(
    `/upload/?token=${tokenData.token}&folder=default`,
    data
  );

  return response.data;
};

export const getMediaUploadingStatus = async (task) => {
  let response = await uploaderClient.get(`/task/${task}`);

  return response.data;
};

export const updateMedia = async (media) => {
  let response = await libraryClient.put(`/api/media/${media.key}`, {
    title: media.metadata.title,
    artist: media.metadata.artist,
    album: media.metadata.album,
  });

  return response.data;
};

export { libraryClient, uploaderClient };
